import React from "react";

export default function InstitutionReportView({ data, onDownload, downloadLoading }) {
  if (!data) return null;

  const { narrative, institutionName, period, totalLearners } = data;

  return (
    <div style={s.wrap}>
      <h1 style={s.title}>BeIntelli Institution Report</h1>

      <div style={s.meta}>
        <Row label="Institution"      value={institutionName || "—"} />
        <Row label="Reporting Period" value={period || "—"} />
        {totalLearners != null && <Row label="Students Assessed" value={totalLearners} />}
      </div>

      <hr style={s.divider} />

      <Section title="Executive Summary">
        <p style={s.bodyText}>{narrative?.executive_summary || "No data available."}</p>
      </Section>

      <Section title="Cohort Trends">
        <OList items={narrative?.cohort_trends} empty="No trend data." />
      </Section>

      <Section title="Domain Performance">
        {narrative?.domain_performance?.length ? (
          <ol style={s.list}>
            {narrative.domain_performance.map((d, i) => (
              <li key={i} style={s.li}>
                <strong>{d.domain}:</strong> {d.performance}
              </li>
            ))}
          </ol>
        ) : <p style={s.empty}>No domain data available.</p>}
      </Section>

      <Section title="Recommendations">
        <OList items={narrative?.recommendations} empty="No recommendations yet." />
      </Section>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
        <button style={s.dlBtn} onClick={onDownload} disabled={downloadLoading}>
          {downloadLoading ? "Generating PDF…" : "⬇ Download PDF"}
        </button>
      </div>

      <p style={s.note}>
        This report provides observational insights for institutional planning purposes only.
      </p>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <h2 style={sec.title}>{title}</h2>
      <div style={sec.line} />
      <div style={{ marginTop: 10 }}>{children}</div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ display: "flex", marginBottom: 4, fontSize: 13 }}>
      <strong style={{ minWidth: 175, color: "#1e293b" }}>{label}:</strong>
      <span style={{ color: "#334155" }}>{value}</span>
    </div>
  );
}

function OList({ items, empty }) {
  if (!items?.length) return <p style={s.empty}>{empty}</p>;
  return (
    <ol style={s.list}>
      {items.map((item, i) => <li key={i} style={s.li}>{item}</li>)}
    </ol>
  );
}

const s = {
  wrap:     { background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "36px 40px", maxWidth: 700, margin: "0 auto" },
  title:    { fontSize: 22, fontWeight: 800, textAlign: "center", marginBottom: 20, color: "#1e293b" },
  meta:     { marginBottom: 20 },
  divider:  { border: "none", borderTop: "1px solid #e2e8f0", margin: "0 0 24px" },
  bodyText: { lineHeight: 1.75, color: "#334155", fontSize: 13 },
  list:     { paddingLeft: 0, listStyle: "none", margin: 0 },
  li:       { padding: "4px 0", fontSize: 13, lineHeight: 1.65, color: "#334155" },
  empty:    { color: "#94a3b8", fontSize: 13 },
  dlBtn:    { padding: "10px 24px", background: "#1e293b", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer" },
  note:     { marginTop: 20, fontSize: 11, color: "#94a3b8", borderTop: "1px solid #e2e8f0", paddingTop: 12 },
};

const sec = {
  title: { fontSize: 15, fontWeight: 700, color: "#1e293b", marginBottom: 4 },
  line:  { height: 2, background: "#1e293b", borderRadius: 1 },
};
